import React from "react";
import { useNavigate } from "react-router-dom";
import Recorder from "../../QuestionPage/recorder";
import ImageBox from "../../QuestionPage/ImageBox";
import { useState, useEffect } from "react";

// Fetching Data from the API]

// End

// Page Html
export default function DescribeImageMockPage(props) {

  const { question, onInputChange, questionNumber } = props;
  const [text, setText] = useState("");
  // End
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/");
  };

  const mockData = question;
  console.log("Mock Dec:", mockData)

  const [ImgLink, setImgLink] = useState("");

  // useEffect(()=>{
  //   setImgLink(question.media_link)
  // })

  useEffect(() => {
    const fetchImageUrl = async () => {
      try {
        const res = await fetch(question.media_link);
        const data = await res.json(); // expecting { url: "..." }
        setImgLink(data.url);
      } catch (err) {
        console.error("Failed to fetch image URL:", err);
      }
    };
  
    if (question?.media_link) {
      fetchImageUrl();
    }
  }, [question]);

  const handleTextChange = (newText) => {
    if (newText !== text) {
      setText(newText);
      onInputChange(newText);
    }
  };
  return (
    <div>
      <div className="relative top-10 bg-gray-100 max-w-full py-5 px-5 md:px-10 mx-4 rounded-sm border border-t-2">
        <div className="max-w-full bg-blue-500 h-3"></div>
        <h3 className="text-lg  pt-3 font-bold text-gray-900 sm:text-2xl ml-1 text-center md:text-start">
          Mock Test
        </h3>
        <h2 className=" absolute  text-1xl font-bold right-10 top-10">
          {" "}
        </h2>
        <h2 className=" absolute  text-sm font-semibold text-gray-700 right-10 top-13">
          {" "}
          Question {questionNumber} of 36
        </h2>
        <p className="p-2">
        Look at the Image below. In 25 seconds,please speak into the microphone and describe in detail what the graph showing. You will have 40 seconds to give your response.



        </p>

        <div className="flex">
          <div className="flex-1">
            <ImageBox link={ImgLink} />
          </div>
          <div className="flex-1">
          <Recorder
              text={text}
              setText={handleTextChange}
              {...props}
              duration={20}
              className="relative ml-6 mt-5 mb-5 bg-gray-100 w-[440px] h-56 border-4"
            />            </div>
        </div>
      </div>
    </div>
  );
}
